import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
})

router.afterEach((to) => {
  if (to.meta.showTitle) {
    document.title = to.meta.title ?? '万成管理系统'
  }
})

export default router
